import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import { mapGetters } from 'vuex';
export default {
  components: {
    PageNavBackLayoutCpt
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  methods: {}
};